import { Chip } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

export default function StatusChipComponent({ status }) {
  const { t } = useTranslation()
  const getChip = useCallback(() => {
    switch (status) {
      case 'Ok':
        return (
          <Chip
            label="OK"
            size='small'
            sx={{
              backgroundColor: "#B9F6CA",
              color: "#00C853",
              fontWeight: 500,
            }}
          />)
      case 'OK':
        return (
          <Chip
            label="OK"
            size='small'
            sx={{
              backgroundColor: "#B9F6CA",
              color: "#00C853",
              fontWeight: 500,
            }}
          />)
      case 'Critico':
        return (
          <Chip
            label={t('critic')}
            size='small'
            sx={{
              backgroundColor: "#FFCECE",
              color: "#D90001",
              fontWeight: 500,
            }}
          />
        )

      case 'Attenzione':
        return (
          <Chip
            label={t('warning')}
            size='small'
            sx={{
              backgroundColor: "#ffe082",
              color: "#ffa000",
              fontWeight: 500,
            }}
          />
        )
      case 'Info':
        return (
          <Chip label="Info"  size='small'/>)

      default: return <></>
    }

  }, [status, t])

  return getChip()
};

